// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__GTi6i","content":"styles_content__A3g0b"};